// Experience Makers - cooking classes, workshops, coaches, individual guides
export const EXP_IMAGES = {
  // Hero: outdoor cooking class - the flagship "experience maker" shot
  hero: "https://customer-assets-agu9un31.emergentagent.net/job_booking-showcase-15/artifacts/v46ukx5i_IMG-20260731-WA0017~2.jpg",
  // Spa treatment in tropical pavilion - authentic wellness experience
  wine: "https://customer-assets-agu9un31.emergentagent.net/job_booking-showcase-15/artifacts/p14r8bqm_IMG-20260731-WA0019~2.jpg",
  // Guided boat tour with karst islands
  coffee: "https://customer-assets-agu9un31.emergentagent.net/job_booking-showcase-15/artifacts/atpzsryl_IMG-20260731-WA0015.jpg",
  // Collage of varied experiences - showcases the breadth of makers
  bar: "https://customer-assets-agu9un31.emergentagent.net/job_booking-showcase-15/artifacts/6rqj14r7_IMG-20260731-WA0012.jpg",
};

const en = {
  hero: {
    eyebrow: "For Experience Makers",
    h1a: "Turn your craft",
    h1b: "into bookings.",
    p: "Cooking classes, workshops, coaches, instructors and individual tour guides - list your experience once and get discovered by the whole island, commission-free.",
    zero: "Zero commissions,",
    ever: "ever",
    cta: "Claim your business",
    tagline: "Live in minutes \u00b7 No commissions ever \u00b7 Cancel anytime",
  },
  chips: [
    { icon: "ChefHat", label: "Cooking classes" },
    { icon: "BookOpen", label: "Workshops" },
    { icon: "GraduationCap", label: "Coaches & instructors" },
    { icon: "Compass", label: "Individual tour guides" },
    { icon: "Camera", label: "Photography tours" },
    { icon: "Palette", label: "Art & craft classes" },
    { icon: "Music", label: "Music lessons" },
    { icon: "Sparkles", label: "One-of-a-kind sessions" },
  ],
  benefits: {
    eyebrow: "Why andAbout",
    h2a: "One profile,",
    h2b: "unlimited experiences.",
    p: "Independent makers don't have marketing budgets or booking engines. andAbout gives you a real profile, real translations and real payments - so your craft can be a business.",
    items: [
      { icon: "Layers", title: "List every experience you offer", body: "Group classes, private sessions, workshops, one-on-one coaching, custom itineraries - list them side by side with prices, schedules and photos." },
      { icon: "Languages", title: "Descriptions in every language", body: "Write your experience once in English. andAbout automatically translates it into 12+ languages so every guest sees it in theirs." },
      { icon: "CalendarCheck2", title: "Direct bookings & deposits", body: "Guests book and pay a deposit or the full session upfront. No more \"can I confirm tomorrow?\" no-shows." },
      { icon: "Star", title: "A profile people trust", body: "Your photos, your bio, your reviews, your certifications - all in one shareable profile you can put on Instagram, WhatsApp or your own website." },
    ],
  },
  audience: {
    eyebrow: "Who finds you",
    h2a: "The whole island,",
    h2b: "not just word of mouth.",
    p: "Right now your bookings depend on a friend recommending you. andAbout puts you in front of everyone actively looking for what you teach.",
    items: [
      { tag: "01", heading: "Curious tourists", body: "Travelers looking for a cooking class, a Muay Thai lesson or a photography tour tonight - they find you in their own language." },
      { tag: "02", heading: "Hotel guests", body: "Concierges recommend your class or session and let guests book directly from your andAbout profile." },
      { tag: "03", heading: "Locals with time to learn", body: "Residents looking to pick up a new skill find your workshops and become repeat students." },
    ],
    stats: [
      { k: "48k+", v: "monthly island searches" },
      { k: "12", v: "languages, auto-translated" },
      { k: "0%", v: "commission on your bookings" },
      { k: "20 min", v: "average time to go live" },
    ],
  },
  marketing: {
    eyebrow: "Included with your subscription",
    h2a: "We put you in",
    h2b: "our marketing.",
    p: "andAbout runs campaigns across the island every day, on social and in search. As a subscriber, your class, workshop or private tour becomes part of the story we tell curious travelers. You bring the craft - we bring the students.",
  },
  steps: {
    eyebrow: "Getting started",
    h2a: "Live in minutes,",
    h2b: "not months.",
    items: [
      { n: "1", title: "Claim your business", body: "Your profile may already exist. Claim it in minutes." },
      { n: "2", title: "Publish your experiences", body: "Add group classes, private sessions, prices, schedules and photos." },
      { n: "3", title: "Book directly", body: "Guests find you and book. You keep every baht - andAbout never takes a commission." },
    ],
  },
  faq: {
    eyebrow: "Questions & answers",
    h2a: "Everything you were",
    h2b: "about to ask.",
    items: [
      { q: "Do you really take zero commission?", a: "Yes. andAbout charges a flat monthly subscription and never takes a cut of your sessions. Card payments are processed by Stripe, and the full processing cost is passed through from Stripe with no markup: by default, 3% is added at checkout for the customer and 2% is charged to the business." },
      { q: "I only run a few classes a month - do I need Plus or Partner?", a: "Start with Basic if you want to be discovered and translated only. Move to Plus once you want direct online bookings with deposits. You can upgrade any time." },
      { q: "Can I take a deposit or full payment upfront?", a: "Both. Set your experience to full-payment or deposit-only, and guests pay by card at booking. Money settles to your bank up to 7 days after the session." },
      { q: "How do guests actually book?", a: "Through the andAbout app or website. Guests see live availability, book their date, pay by card and get an automatic confirmation - no WhatsApp back-and-forth." },
      { q: "When do I get paid?", a: "Up to 7 days after the guest attended. Guests can cancel up to 48 hours before the session for a full refund, so payout is settled once that window has passed." },
      { q: "Can we cancel anytime?", a: "Yes. Both Plus and Partner are month-to-month. Annual plans include two months free but you can still cancel renewal any time." },
    ],
  },
};
export const EXP_TRANSLATIONS = { en, th: en, ru: en };
